import { render } from "./BangChon.vue?vue&type=template&id=208b74cc&scoped=true&ts=true"
import script from "./BangChon.vue?vue&type=script&lang=ts"
export * from "./BangChon.vue?vue&type=script&lang=ts"

import "./BangChon.vue?vue&type=style&index=0&id=208b74cc&scoped=true&lang=css"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/PHCN/ChiaGioThucHien/VLTL_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208b74cc"]])

export default __exports__